import type { StepContentConfig } from '@workspace/core-ts/utils';

const recapitulatifContent: StepContentConfig = {
    mainTitle: {
        site: 'Récapitulatif de votre assurance',
        conseiller: "Récapitulatif de l'assurance de votre client",
    },
    vehiculeTitle: {
        site: 'Mon vélo',
        conseiller: 'Vélo du client',
    },
    informationsTitle: {
        site: 'Mes informations',
        conseiller: 'Informations du client',
    },
    documentsTitle: {
        site: 'Mes documents',
        conseiller: 'Documents du client',
    },
    numeroMarquageTitle: {
        site: 'Numéro de marquage (Bicycode, MFC, Paravol, Recobike, Auvray security, Décathlon)',
        conseiller: 'Numéro de marquage (Bicycode, MFC, Paravol, Recobike, Auvray security, Décathlon)',
    },
    numeroMarquageWarning: {
        site: 'Attention, en cas de vol ou de tentative de vol, sans cette information l’indemnité due sera réduite de 50 %. Le numéro de marquage est obligatoire pour tout vélo neuf acheté en France depuis le 1er janvier 2021.',
        conseiller:
            'Attention, en cas de vol ou de tentative de vol, sans cette information l’indemnité due sera réduite de 50 %. Le numéro de marquage est obligatoire pour tout vélo neuf acheté en France depuis le 1er janvier 2021.',
    },
};

export default recapitulatifContent;
